<template>
  <v-container>
    <v-row
      ><v-col cols="0" lg="0" xl="1"></v-col
      ><v-col cols="12" lg="12" xl="10">
        <div class="text-center pt-16" v-if="isLoading">
          <v-progress-circular
            indeterminate
            color="blue-grey darken-1"
          ></v-progress-circular>
        </div>
        <v-data-table
          v-if="!isLoading"
          ref="vDataTable"
          v-model="selected"
          :headers="headers"
          :items="desserts"
          :single-select="singleSelect"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          :search="search"
          item-key="userNo"
          :items-per-page="-1"
        >
          <template v-slot:top>
            <v-toolbar
              :flat="offsetTop <= 0"
              style="
                position: sticky;
                top: 73px;
                background-color: #fff;
                z-index: 1;
              "
            >
              <v-toolbar-title>使用者列表</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-dialog persistent v-model="dialog" max-width="960px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="blue-grey lighten-1"
                    style="height: 40px"
                    depressed
                    dark
                    class="mb-2 mt-2"
                    @click="next()"
                  >
                    載入更多
                  </v-btn>
                  <v-btn
                    color="blue-grey"
                    style="height: 40px"
                    depressed
                    dark
                    class="mb-2 mt-2 mr-2"
                    @click="exportExcel()"
                  >
                    匯出 Excel </v-btn
                  ><v-spacer></v-spacer>
                  <v-btn
                    color="blue-grey"
                    dark
                    class="mb-2 d-none"
                    v-bind="attrs"
                    v-on="on"
                  >
                    新增 </v-btn
                  ><v-spacer></v-spacer
                  ><v-btn
                    color="blue-grey"
                    style="height: 40px"
                    dark
                    class="mb-2 mt-2 ml-2"
                    @click="clearQuery()"
                  >
                    清除 </v-btn
                  ><v-btn
                    color="blue-grey"
                    style="height: 40px"
                    dark
                    class="mb-2 mt-2 ml-2"
                    @click="queryByPhoneNumber()"
                  >
                    手機搜尋
                  </v-btn>
                  <v-btn
                    color="blue-grey"
                    dark
                    style="height: 40px"
                    class="mb-2 mt-2 ml-3"
                    @click="queryByUserNo()"
                  >
                    員編搜尋
                  </v-btn>
                  <!--<v-switch
                    v-model="singleExpand"
                    label="Single expand"
                    class="pa-3"
                  ></v-switch>
                  <v-switch
                    v-model="singleSelect"
                    label="Single select"
                    class="pa-3"
                  ></v-switch>-->
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </template>
                <v-card>
                  <v-toolbar color="primary" dark>
                    <v-toolbar-title>{{ formTitle }}</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn icon @click="dialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>

                  <v-card-text class="pt-6">
                    <v-container>
                      <v-row>
                        <v-col cols="12" md="4">
                          <v-img
                            :lazy-src="
                              template.photoUrl
                                ? template.photoUrl
                                : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                            "
                            :src="
                              template.photoUrl
                                ? template.photoUrl
                                : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                            "
                          ></v-img>
                        </v-col>
                        <v-col cols="12" md="8">
                          <v-row>
                            <!--<v-col cols="12">
                              <v-text-field
                                v-model="template.photoUrl"
                                label="圖片網址"
                                hide-details="true"
                                dense
                                outlined
                                required
                              ></v-text-field
                            ></v-col>
                            <v-col cols="12">
                              <v-file-input
                                v-model="photoFile"
                                label="File input"
                                @change="onFileChange"
                                hide-details="true"
                                outlined
                                dense
                                accept="image/png, image/jpeg, image/bmp"
                              ></v-file-input
                            ></v-col>-->
                            <v-col cols="12">
                              <!--<v-btn
                                depressed
                                color="orange lighten-1"
                                class="white--text"
                                @click="showUploadImg"
                              >
                                上傳圖片
                              </v-btn>-->
                              <v-btn
                                depressed
                                color="grey"
                                class="ml-2 white--text"
                                @click="template.photoUrl = ''"
                              >
                                清除圖片
                              </v-btn></v-col
                            >
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                      取消
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="save">
                      儲存
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="text-h5"
                    >Are you sure you want to disable this item?</v-card-title
                  >
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete"
                      >取消</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                      >確認</v-btn
                    >
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:[`item.devToken.ANDROID`]="{ item }">
            <div>{{ `${item.devToken.ANDROID ? "Y" : "N"}` }}</div>
          </template>
          <template v-slot:[`item.devToken.IOS`]="{ item }">
            <div>{{ `${item.devToken.IOS ? "Y" : "N"}` }}</div>
          </template>
          <template v-slot:[`item.pushEnable`]="{ item }">
            <v-simple-checkbox
              v-model="item.pushEnable"
              :ripple="false"
              class="ml-3"
              disabled
            ></v-simple-checkbox>
          </template>
          <template v-slot:[`item.profileIsCompleted`]="{ item }">
            <v-simple-checkbox
              v-model="item.profileIsCompleted"
              :ripple="false"
              class="ml-3"
              disabled
            ></v-simple-checkbox>
          </template>
          <template v-slot:[`item.disabled`]="{ item }">
            <v-simple-checkbox
              v-model="item.disabled"
              :ripple="false"
              class="ml-3"
              disabled
            ></v-simple-checkbox>
          </template>
          <template v-slot:[`item.userStatus`]="{ item }">
            <v-simple-checkbox
              :value="!!item.userStatus"
              :ripple="false"
              class="ml-3"
              disabled
            ></v-simple-checkbox>
          </template>
          <template v-slot:[`item.actionsEdit`]="{ item }">
            <v-icon @click="editItem(item)" style="font-size: 19px">
              mdi-pencil
            </v-icon>
            <!--<v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>-->
          </template>
          <template v-slot:[`item.actionsDel`]="{ item }">
            <v-icon small @click="deleteItem(item)"> mdi-cancel </v-icon>
          </template>
          <template v-slot:[`item.data-table-expand`]="props">
            <v-icon
              :class="{
                'v-data-table__expand-icon': true,
                'v-data-table__expand-icon--active':
                  props.isExpanded && transitioned[getItemId(props.item)],
              }"
              @click="toggleExpand(props)"
            >
              mdi-chevron-down
            </v-icon>
          </template>

          <!--展開內容-->
          <template v-slot:[`expanded-item`]="{ headers, item }">
            <td
              :colspan="headers.length"
              :class="{
                'ma-0 pa-0': true,
                'expanded-closing': !transitioned[getItemId(item)],
              }"
              style="height: auto"
            >
              <v-expand-transition>
                <div v-show="transitioned[getItemId(item)]">
                  <div class="pa-2" style="min-height: 100px">
                    <!--<span>{{ item }}</span>-->
                    <v-form>
                      <v-container class="my-6">
                        <v-row
                          ><v-col cols="12" md="4">
                            <v-img
                              style="width: 98%; max-width: 1000px"
                              :lazy-src="
                                item.photoUrl
                                  ? item.photoUrl
                                  : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                              "
                              :src="
                                item.photoUrl
                                  ? item.photoUrl
                                  : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                              "
                              cover
                            ></v-img>
                          </v-col>
                          <v-col cols="12" md="8">
                            <div class="d-flex justify-space-between">
                              <div>
                                <div
                                  class="grey--text text--darken-1 text-subtitle-2 mb-2 font-weight-regular"
                                >
                                  企業編號 -
                                  {{ item.compNo }}
                                </div>
                                <p
                                  class="text-h4 font-weight-black text--primary mb-ˋ"
                                >
                                  {{ item.compName }}
                                </p>
                              </div>
                              <div></div>
                            </div>
                            <hr
                              class="v-divider theme--light border-dashed mb-4"
                              style="border-style: dashed"
                            />
                            <v-row>
                              <v-col cols="12" md="12">
                                <v-row>
                                  <!--<v-col cols="12" md="3"
                                    ><p
                                      class="text-subtitle-2 font-weight-black mb-1"
                                    >
                                      E-mail
                                    </p>
                                    <div
                                      class="text-subtitle-1 grey--text text--darken-2 mb-4"
                                      style="word-break: break-all"
                                    >
                                      {{ item.email }}
                                    </div></v-col
                                  >-->
                                  <v-col cols="12" md="4"
                                    ><p
                                      class="text-subtitle-2 font-weight-black mb-1"
                                    >
                                      電話
                                    </p>
                                    <div
                                      class="text-subtitle-1 grey--text text--darken-2 mb-4"
                                    >
                                      {{ item.phoneNumber }}
                                    </div></v-col
                                  >
                                  <v-col cols="12" md="4"
                                    ><p
                                      class="text-subtitle-2 font-weight-black mb-1"
                                    >
                                      員編
                                    </p>
                                    <div
                                      class="text-subtitle-1 grey--text text--darken-2 mb-2"
                                      style="
                                        text-align: justify;
                                        word-break: break-all;
                                      "
                                    >
                                      {{ item.userNo }}
                                    </div></v-col
                                  >
                                  <v-col cols="12" md="4"
                                    ><p
                                      class="text-subtitle-2 font-weight-black mb-1"
                                    >
                                      生日月分
                                    </p>
                                    <div
                                      class="text-subtitle-1 grey--text text--darken-2 mb-2"
                                      style="
                                        text-align: justify;
                                        word-break: break-all;
                                      "
                                    >
                                      {{ item.birthday }}
                                    </div></v-col
                                  >
                                </v-row>
                              </v-col>
                            </v-row></v-col
                          >
                        </v-row>
                      </v-container>
                    </v-form>
                  </div>
                </div>
              </v-expand-transition>
            </td>
          </template>
        </v-data-table></v-col
      ><v-col cols="0" lg="0" xl="1"></v-col
    ></v-row>
    <v-dialog v-model="dialog_showUploadImg" width="860">
      <v-toolbar color="primary" dark>
        <v-toolbar-title>上傳圖片</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog_showUploadImg = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <cropperDialogs
        @update="getImgFile"
        :cropRatio="[1, 1]"
        :cropWidth="500"
        v-if="dialog_showUploadImg"
      ></cropperDialogs>
    </v-dialog>
  </v-container>
</template>

<script>
import ExcelJs from "exceljs";
import cropperDialogs from "@/components/cropperDialogs.vue";
import { ref, getDownloadURL, uploadBytes } from "firebase/storage";
import { db, storage } from "@/firebase";
import { apiAxios } from "@/api";
import {
  query,
  where,
  collection,
  getDocs,
  setDoc,
  doc,
  orderBy,
  startAfter,
  limit,
} from "firebase/firestore/lite";

export default {
  components: {
    cropperDialogs,
  },
  data: () => ({
    offsetTop: 0,
    isLoading: true,
    dialog_showUploadImg: false,
    startTimeMenu: false,
    endTimeMenu: false,
    search: "",
    singleSelect: false,
    selected: [],
    expanded: [],
    singleExpand: false,
    dialog: false,
    dialogDelete: false,
    headers: [
      { text: "員工編號", value: "userNo", width: "10%" },
      { text: "所屬公司", value: "compName", width: "10%" },
      { text: "性別", value: "gender" },
      { text: "手機", value: "phoneNumber" },
      // { text: "ANDROID", value: "devToken.ANDROID", width: "10%" },
      // { text: "IOS", value: "devToken.IOS", width: "10%" },
      {
        text: "接收推播",
        value: "pushEnable",
        align: "center",
        sortable: false,
        width: "8%",
      },
      {
        text: "資料完整",
        value: "profileIsCompleted",
        align: "center",
        sortable: false,
        width: "8%",
      },
      {
        text: "啟用狀態",
        value: "userStatus",
        align: "center",
        sortable: false,
        width: "8%",
      },
      {
        text: "編輯",
        value: "actionsEdit",
        sortable: false,
        align: "center",
        width: "6%",
      },
      // {
      //   text: "停用",
      //   value: "actionsDel",
      //   sortable: false,
      //   align: "center",
      //   width: "6%",
      // },
      // {
      //   text: "展開",
      //   value: "data-table-expand",
      //   sortable: false,
      //   align: "center",
      //   width: "6%",
      // },
    ],
    desserts: [],
    citys: [],
    actTypes: [],
    expireds: ["Y", "N"],
    editedIndex: -1,
    defaultItem: {},
    template: {},
    transitioned: [],
    closeTimeouts: {},
    newStoreId: "",
    photoFile: null,
    lastVisible: {},
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "新增" : "編輯";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    singleExpand(v) {
      if (!v) return;
      // Single expand enabled. Hide all but the first expanded item
      this.expanded.forEach((item, i) => {
        if (i > 0) this.closeExpand(item);
      });
    },
  },

  async created() {
    this.$bus.$emit("sideBarSelectedItem:push", 5);
    this.getUsers();
    // this.getAllUser();
    window.addEventListener("scroll", this.handleScroll);
    // console.log(this.formatDate(new Date()));
    // console.log(this.formatTime(new Date()));
  },

  methods: {
    async getAllUser() {
      const querySnapshot = await getDocs(collection(db, "users"));
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        // console.log(doc.id, " => ", doc.data());
        let data = doc.data();
        data.userId = doc.id;
        if (data.createTime) {
          this.desserts.push(data);
        }
      });
      this.isLoading = false;
    },
    async queryByUserNo() {
      if (this.search) {
        this.desserts = [];
        const usersRef = collection(db, "users");
        const q = query(usersRef, where("userNo", "==", this.search));
        const documentSnapshots = await getDocs(q);
        documentSnapshots.forEach((doc) => {
          let data;
          data = JSON.parse(JSON.stringify(doc.data()));
          console.log(doc.id, " => ", doc.data());
          if (data.createTime) {
            this.desserts.push(data);
          }
        });
        if (this.desserts.length === 0) {
          this.$snackbar.add(`暫時沒有符合的資料`, { color: "error" });
        }
      }
    },
    async queryByPhoneNumber() {
      if (this.search) {
        this.desserts = [];
        const usersRef = collection(db, "users");
        const q = query(usersRef, where("phoneNumber", "==", this.search));
        const documentSnapshots = await getDocs(q);
        documentSnapshots.forEach((doc) => {
          let data;
          data = JSON.parse(JSON.stringify(doc.data()));
          console.log(doc.id, " => ", doc.data());
          this.desserts.push(data);
        });
        if (this.desserts.length === 0) {
          this.$snackbar.add(`暫時沒有符合的資料`, { color: "error" });
        }
      }
    },
    clearQuery() {
      this.desserts = [];
      this.search = "";
      this.getUsers();
    },
    setAuthUpdateUserDisabled(id) {
      return apiAxios({
        method: "post",
        url: `/FireBase/AuthUpdateUserDisabled?Uid=${id}&Disabled=true`,
      }).then((res) => {
        console.log("setAuthUpdateUserDisabled", res);
        this.$snackbar.add(`禁用成功`, { color: "success" });
      });
    },
    showUploadImg() {
      this.dialog_showUploadImg = true;
    },
    getImgFile(file) {
      fetch(file)
        .then((res) => res.blob())
        .then((res) => {
          this.template.photoUrl = URL.createObjectURL(res);
          this.photoFile = res;
          this.dialog_showUploadImg = false;
          console.log(res);
        });
    },
    async getUsers() {
      const first = query(
        collection(db, "users"),
        orderBy("createTime", "desc"),
        limit(50)
      );
      const documentSnapshots = await getDocs(first);
      console.log(documentSnapshots);
      documentSnapshots.forEach((doc) => {
        let data;
        data = JSON.parse(JSON.stringify(doc.data()));
        if (data.userNo) {
          // console.log(doc.id, " => ", doc.data());
          this.desserts.push(data);
        }
      });
      console.log(this.desserts)
      this.lastVisible =
        documentSnapshots.docs[documentSnapshots.docs.length - 1];
      this.isLoading = false;
    },
    async next() {
      if (this.lastVisible) {
        const next = query(
          collection(db, "users"),
          orderBy("createTime", "desc"),
          startAfter(this.lastVisible),
          limit(50)
        );

        const documentSnapshots = await getDocs(next);

        if (documentSnapshots.docs.length == 0) {
          this.$snackbar.add(`沒有更多了`, { color: "success" });
        } else if (documentSnapshots.docs.length < 50) {
          this.lastVisible = "";
        } else {
          this.lastVisible =
            documentSnapshots.docs[documentSnapshots.docs.length - 1];
        }

        documentSnapshots.forEach((doc) => {
          let data;
          data = JSON.parse(JSON.stringify(doc.data()));
          console.log(doc.id, " => ", doc.data());
          this.desserts.push(data);
        });
      } else {
        this.$snackbar.add(`沒有更多了`, { color: "success" });
      }
    },
    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.template = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.template = Object.assign({}, item);

      this.dialogDelete = true;
    },
    async deleteItemConfirm() {
      const q = query(
        collection(db, "users"),
        where("phoneNumber", "==", this.template.phoneNumber)
      );

      const querySnapshot = await getDocs(q);
      console.log(querySnapshot._docs[0].id);
      this.setAuthUpdateUserDisabled(querySnapshot._docs[0].id);
      this.desserts = [];
      this.getUsers();
      this.closeDelete();
    },
    close() {
      this.logoFile = null;
      this.mainPictureFile = null;
      this.dialog = false;
      this.$nextTick(() => {
        this.template = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.template = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    onFileChange(event) {
      let files = event;
      if (JSON.stringify(files) !== "{}") return;
      if (Math.round(files.size, (Math / 1024) * 100) / 1000000 > 5) {
        alert("圖檔尺寸大於5MB，請壓縮後重新上傳");
        return;
      }

      if (this.photoFile && this.dialog) {
        this.template.photoUrl = URL.createObjectURL(this.photoFile);
      }
    },
    getFileExtension(filename) {
      return filename.slice(((filename.lastIndexOf("/") - 1) >>> 0) + 2);
    },
    async save() {
      if (this.editedIndex > -1) {
        console.log("編輯");
        const q = query(
          collection(db, "users"),
          where("phoneNumber", "==", this.template.phoneNumber)
        );
        const querySnapshot = await getDocs(q);

        if (this.photoFile) {
          let fileName = `profilePicture.${this.getFileExtension(
            this.photoFile.type
          )}`;
          console.log(fileName);
          await uploadBytes(
            ref(
              storage,
              `/profilePhoto/${querySnapshot._docs[0].id}/${fileName}`
            ),
            this.photoFile
          ).then(async (snapshot) => {
            console.log("Uploaded a blob or file!(logo)", snapshot);
            await getDownloadURL(
              ref(
                storage,
                `/profilePhoto/${querySnapshot._docs[0].id}/${fileName}`
              )
            ).then((url) => {
              console.log(url);
              this.template.photoUrl = url;
            });
          });
        }

        if (!this.template.photoUrl) {
          this.template.profileIsCompleted = false;
        }

        this.template.updateTime = Number(this.timest());

        await setDoc(
          doc(db, "users", querySnapshot._docs[0].id),
          this.template
        );
      }
      this.logoFile = null;
      this.desserts = [];
      this.getUsers();
      this.$snackbar.add(`修改完成`, { color: "success" });
      this.close();
    },
    getItemId(item) {
      return item.userNo; // Must be uid of record (would be nice if v-data-table exposed a "getItemKey" method)
    },
    toggleExpand(props) {
      const item = props.item;
      const id = this.getItemId(item);
      if (props.isExpanded && this.transitioned[id]) {
        // If we're expanded and not in the process of closing, close
        this.closeExpand(item);
      } else {
        // If we're closed or in the process of closing, expand
        // Stop us from closing if a close transition was started
        clearTimeout(this.closeTimeouts[id]);
        // Tell v-data-table to add the expansion content for the item
        props.expand(true);
        // Show expansion content with transition animation after it's had time to get added to the DOM
        this.$nextTick(() => this.$set(this.transitioned, id, true));
        // Hide all other expanded items if single-expand
        if (this.singleExpand)
          this.$nextTick(() =>
            this.expanded.forEach((i) => i !== item && this.closeExpand(i))
          );
      }
    },
    closeExpand(item) {
      const id = this.getItemId(item);
      // Mark that this item is in the process of closing
      this.$set(this.transitioned, id, false);
      // Remove expansion content from DOM after transition animation has had enough time to finish
      this.closeTimeouts[id] = setTimeout(
        () => this.$refs.vDataTable.expand(item, false),
        600
      );
    },
    timest() {
      var tmp = Date.parse(new Date()).toString();
      tmp = tmp.substr(0, 10);
      return tmp;
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    formatTime(date) {
      var d = new Date(date),
        hour = "" + d.getHours(),
        minute = d.getMinutes();

      return [hour, minute].join(":");
    },
    handleScroll() {
      // console.log(
      //   window.scrollY,
      //   window.screen.height,
      //   document.body.scrollHeight
      // );
      this.offsetTop = window.scrollY;
    },
    exportExcel() {
      const workbook = new ExcelJs.Workbook(); // 創建試算表檔案
      const sheet = workbook.addWorksheet("票券列表"); //在檔案中新增工作表 參數放自訂名稱

      sheet.getColumn(1).width = 13;
      sheet.getColumn(2).width = 13;
      sheet.getColumn(3).width = 13;
      sheet.getColumn(4).width = 13;
      sheet.getColumn(5).width = 13;
      sheet.getColumn(6).width = 13;
      sheet.getColumn(7).width = 13;
      sheet.getColumn(8).width = 13;
      // sheet.getColumn(9).width = 13;

      let data = [];
      this.desserts.forEach(function (item) {
        data.push([
          item.birthday,
          item.compName,
          item.compNo,
          item.createTime,
          item.email,
          item.gender,
          item.phoneNumber,
          item.userNo,
          // item.userId,
        ]);
      });
      sheet.addTable({
        // 在工作表裡面指定位置、格式並用columsn與rows屬性填寫內容
        name: "table名稱", // 表格內看不到的，算是key值，讓你之後想要針對這個table去做額外設定的時候，可以指定到這個table
        ref: "A1", // 從A1開始
        columns: [
          { name: "生日" },
          { name: "所屬公司" },
          { name: "公司編號" },
          { name: "創建日期" },
          { name: "Email" },
          { name: "性別" },
          { name: "手機號碼" },
          { name: "員工編號" },
          // { name: "userId" },
        ],
        rows: data,
      });

      // 表格裡面的資料都填寫完成之後，訂出下載的callback function
      // 異步的等待他處理完之後，創建url與連結，觸發下載
      workbook.xlsx.writeBuffer().then((content) => {
        const link = document.createElement("a");
        const blobData = new Blob([content], {
          type: "application/vnd.ms-excel;charset=utf-8;",
        });
        link.download = `統一企業集團特約商店 ${this.formatDate(
          new Date()
        )}.xlsx`;
        link.href = URL.createObjectURL(blobData);
        link.click();
      });
    },
  },
};
</script>
